import React, { useEffect, useState } from 'react'

import {
  FaChevronLeft,
  FaChevronRight,
  FaFacebookF,
  FaInstagramSquare,
  FaList,
  FaLock,
  FaRegHeart,
  FaUser,
} from 'react-icons/fa'
import { IoMdArrowDropdown } from 'react-icons/io'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { IoIosArrowDown } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { get_card_products, get_wishlist } from '../store/reducers/cardReducer'
import {
  get_categories,
  get_sub_categories,
} from '../store/reducers/homeReducer'
import { backend_url_img } from '../api/server'

import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import cookies from 'js-cookie'
import { AiOutlineShopping } from 'react-icons/ai'

const languages = [
  {
    code: 'en',
    name: 'English',
    dir: 'ltr',
    country_code: 'en',
    image: '../../../images/language.png',
  },
  {
    code: 'kr',
    name: 'کوردی',
    dir: 'rtl',
    country_code: 'kr',
    image: '../../../images/kur.png',
  },
  {
    code: 'ar',
    name: 'عربي',
    dir: 'rtl',
    country_code: 'ar',
    image: '../../../images/ar.png',
  },
]

const Header = () => {
  const { t, i18n } = useTranslation()
  const currentLanguageCode = cookies.get('i18next') || 'kr'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const isRTL = currentLanguage.code === 'ar' || currentLanguage.code === 'kr'

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { categoriesView } = useSelector((state) => state.home)
  const { subCategories } = useSelector((state) => state.category)
  const { userInfo } = useSelector((state) => state.auth)
  const { buy_product_item, wishlist_count } = useSelector(
    (state) => state.card,
  )

  useEffect(() => {
    dispatch(get_categories())
    dispatch(get_sub_categories())
  }, [])

  const { pathname } = useLocation()

  const [showShidebar, setShowShidebar] = useState(true)
  const [categoryShow, setCategoryShow] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [searchActive, setSearchActive] = useState(false)

  useEffect(() => {
    document.body.dir = currentLanguage.dir || 'ltr'
    document.title = t('home.app_title')
  }, [currentLanguage, t])

  const search = () => {
    navigate(`/products/search?value=${searchValue}`)
  }

  const redirect_card_page = () => {
    if (userInfo) {
      navigate('/card')
    } else {
      navigate('/login')
    }
  }

  useEffect(() => {
    if (userInfo) {
      dispatch(get_card_products(userInfo?.id))
      dispatch(get_wishlist(userInfo?.id))
    }
    setSearchActive(false)
  }, [userInfo, dispatch])

  useEffect(() => {
    const mybutton = document.getElementById('btn-back-to-top')

    if (mybutton) {
      const scrollFunction = () => {
        if (
          document.body.scrollTop > 20 ||
          document.documentElement.scrollTop > 20
        ) {
          mybutton.classList.remove('hidden')
        } else {
          mybutton.classList.add('hidden')
        }
      }

      const backToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }

      mybutton.addEventListener('click', backToTop)
      window.addEventListener('scroll', scrollFunction)

      // Cleanup function to remove event listeners
      return () => {
        mybutton.removeEventListener('click', backToTop)
        window.removeEventListener('scroll', scrollFunction)
      }
    }
  }, [])

  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const headerLogo = '../../../images/logo.png'

  const getCategoryName = (category) => {
    switch (currentLanguage.code) {
      case 'ar':
        return category?.arName
      case 'kr':
        return category?.kuName
      default:
        return category?.enName
    }
  }

  const getSubCategoryName = (subCategory) => {
    switch (currentLanguage.code) {
      case 'ar':
        return subCategory?.arName
      case 'kr':
        return subCategory?.kuName
      default:
        return subCategory?.enName
    }
  }

  return (
    <div className="w-full bg-white ">
      <div className="header-top bg-slate-100  md-lg:hidden">
        <div className="w-[85%] lg:w-[90%] mx-auto ">
          <div className="flex w-full justify-between items-center h-[50px] text-slate-500">
            <ul className="flex justify-start items-center gap-8 font-semibold text-black"></ul>
            <p className="text-darkRed">
              {' '}
              “This website is strictly for users aged 18+. Our products contain
              nicotine and are intended for adults only.”
            </p>
            <div>
              <div className="flex justify-center items-center gap-10">
                <div className="flex group cursor-pointer text-slate-800 text-sm justify-center items-center gap-1 relative after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px] after:absolute before:absolute before:h-[18px] before:bg-[#afafaf] before:w-[1px] before:-left-[20px]">
                  <img
                    src={currentLanguage.image}
                    className="w-7"
                    alt={currentLanguage.name}
                  />
                  <span>
                    <IoMdArrowDropdown />
                  </span>
                  <ul className="absolute invisible transition-all top-8 rounded-sm duration-200 text-black p-2 w-[100px] flex flex-col gap-3 group-hover:visible group-hover:top-6 group-hover:bg-[#F9FBFE] z-10">
                    {languages?.map(({ code, name, country_code, image }) => (
                      <li key={country_code}>
                        <a
                          href="/"
                          className="dropdown-item"
                          onClick={(e) => {
                            e.preventDefault()
                            i18next.changeLanguage(code)
                          }}
                          disabled={code === currentLanguageCode}
                        >
                          <div className="flex justify-between items-center">
                            {name}
                            <img
                              src={image}
                              className="w-[22px] h-[15px]"
                              alt={`${name} logo`}
                            />
                          </div>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                {userInfo ? (
                  <Link
                    className="flex cursor-pointer justify-center items-center gap-2 text-sm text-black"
                    to="/dashboard"
                  >
                    <span>
                      {' '}
                      <FaUser />{' '}
                    </span>
                    <span> {userInfo.name} </span>
                  </Link>
                ) : (
                  <Link
                    to="/login"
                    className="flex cursor-pointer justify-center items-center gap-2 text-sm text-black"
                  >
                    <span>
                      {' '}
                      <FaLock />{' '}
                    </span>
                    <span>{t('home.login')} </span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="">
        <div className="w-[68%] lg:w-[100%] mx-auto ">
          <div className="h-[90px] md-lg:h-[100px] flex justify-between items-center flex-wrap">
            {/* logo */}
            <div className="md-lg:w-full w-2/12 md-lg:pt-4 sm:pt-2">
              <div className="flex justify-between items-center py-2 px-4 sm:border-b ">
                <Link to="/">
                  <img
                    className="w-[100px] sm:w-[80px] mx-auto"
                    src={headerLogo}
                    alt=""
                  />
                </Link>
                <div
                  className="justify-center items-center w-[35px] h-[35px] bg-primary text-slate-600 border border-slate-600 rounded-sm cursor-pointer lg:hidden md-lg:flex xl:hidden hidden"
                  onClick={() => setShowShidebar(false)}
                >
                  <span>
                    {' '}
                    <FaList size={20} color="white" />{' '}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center sm:w-full md-lg:w-full w-8/12 sm:py-4">
              <div className="flex w-full sm-md:px-2 md-lg:px-4 md-lg:justify-center items-center">
                {/* Search */}
                <div className="flex justify-between items-center w-full px-1 sm:px-4 md-lg:px-0 md-lg:w-full">
                  <div className="flex w-full justify-between items-center md-lg:gap-6">
                    <div className="w-full sm:w-full   md-lg:w-full">
                      <div className="flex border rounded-full h-[45px] sm:h-[45px] items-center relative gap-2">
                        <input
                          className="w-full relative bg-transparent text-slate-500 outline-0 px-5 h-full rtl:space-x-reverse"
                          onChange={(e) => setSearchValue(e.target.value)}
                          type="text"
                          name="search"
                          id="searchInput"
                          placeholder={t('home.need')}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault()
                              search()
                            }
                          }}
                          autoComplete="off"
                        />
                        <button
                          onClick={search}
                          className="bg-darkRed px-8 sm:px-4 ltr:rounded-r-full rtl:rounded-l-full h-full test-sm  uppercase text-white ltr:right-0 rtl:left-0"
                        >
                          {' '}
                          <span>{t('home.search')}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Cart Icon */}
            <div className="flex w-2/12 md-lg:hidden justify-end items-center gap-4">
              <div className="flex justify-center gap-4">
                <div
                  onClick={() =>
                    navigate(userInfo ? '/dashboard/my-wishlist' : '/login')
                  }
                  className="relative flex justify-center items-center cursor-pointer"
                >
                  <span className="text-md text-black">
                    <FaRegHeart className=" w-8 h-8" />
                  </span>

                  {wishlist_count !== 0 && (
                    <div className="w-[20px] h-[20px] absolute bg-red-500 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px] ">
                      {wishlist_count}
                    </div>
                  )}
                </div>

                <div
                  onClick={redirect_card_page}
                  className="relative flex justify-center items-center cursor-pointer"
                >
                  <span className="text-xl text-black">
                    <AiOutlineShopping className=" w-10 h-10" />
                  </span>

                  {buy_product_item !== 0 && (
                    <div className="w-[20px] h-[20px] absolute bg-red-500 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px] ">
                      {buy_product_item}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden md-lg:block">
        <div
          onClick={() => setShowShidebar(true)}
          className={`fixed duration-600 transition-all ${
            showShidebar ? 'invisible' : 'visible'
          } hidden md-lg:block w-screen h-screen bg-[rgba(0,0,0,0.5)] top-0 left-0 z-20 `}
        ></div>

        <div
          className={`w-[300px] z-[99] transition-all duration-200 fixed ${
            showShidebar ? '-left-[300px]' : 'left-0 top-0'
          } overflow-y-auto bg-white h-screen py-6 px-8 `}
        >
          <div className="flex justify-start flex-col gap-6">
            <Link to="/">
              <img className="w-[80px] " src={headerLogo} alt="" />
            </Link>
            <div className="flex justify-start items-center gap-10">
              <div className="flex group cursor-pointer text-slate-800 text-sm justify-center items-center gap-1 relative after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px] after:absolute ">
                <img
                  src={currentLanguage.image}
                  className="w-7"
                  alt={currentLanguage.name}
                />
                <span>
                  <IoMdArrowDropdown />
                </span>
                <ul className="absolute invisible transition-all top-12 rounded-sm duration-200 text-white sm:ml-6 p-2 w-[100px] flex flex-col gap-3 group-hover:visible group-hover:top-6 group-hover:bg-black z-10">
                  {languages?.map(({ code, name, country_code, image }) => (
                    <li key={country_code}>
                      <a
                        href="/"
                        className="dromdown-item "
                        onClick={() => i18next.changeLanguage(code)}
                        disabled={code === currentLanguageCode}
                      >
                        <div className="flex justify-between items-center">
                          {name}
                          <img
                            src={image}
                            className="w-[22px] h-[15px]"
                            alt={`${name} logo`}
                          />
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              {userInfo ? (
                <Link
                  className="flex cursor-pointer justify-center items-center gap-2 text-sm text-black"
                  to="/dashboard"
                >
                  <span>
                    {' '}
                    <FaUser />{' '}
                  </span>
                  <span>{userInfo.name}</span>
                </Link>
              ) : (
                <Link
                  className="flex cursor-pointer justify-center items-center gap-2 text-sm text-black"
                  to="/login"
                >
                  <span>
                    {' '}
                    <FaLock />{' '}
                  </span>
                  <span>{t('home.login')} </span>
                </Link>
              )}
            </div>

            <ul className="flex flex-col justify-start items-start text-sm font-bold uppercase">
              <li>
                <Link
                  to="/"
                  className={`py-2 block ${
                    pathname === '/' ? 'text-primary' : 'text-slate-600'
                  } `}
                >
                  {t('home.home')}
                </Link>
              </li>

              <li>
                <Link
                  to="/categories"
                  className={`py-2 block ${
                    pathname === '/categories'
                      ? 'text-primary'
                      : 'text-slate-600'
                  } `}
                >
                  {t('home.categoreis')}
                </Link>
              </li>

              <li>
                <Link
                  to="/about_us"
                  className={`py-2 block ${
                    pathname === '/about_us' ? 'text-primary' : 'text-slate-600'
                  } `}
                >
                  {t('home.about_us')}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={`py-2 block ${
                    pathname === '/contact' ? 'text-primary' : 'text-slate-600'
                  } `}
                >
                  {t('home.contact_us')}
                </Link>
              </li>
            </ul>
            <div className="flex justify-start items-center gap-4 ">
              <a
                className="w-[38px] h-[38px] text-white hover:bg-[#3b5998] hover:text-white flex justify-center items-center bg-[#3b5998] rounded-full"
                href="#"
              >
                <FaFacebookF size={16} />{' '}
              </a>
              <a
                className="w-[38px] h-[38px] text-white hover:bg-[#E1306C] hover:text-white flex justify-center items-center bg-[#E1306C] rounded-full"
                href="#"
              >
                <FaInstagramSquare size={16} />{' '}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="w-[69%] sm:w-[95%] md:w-[90%] lg:w-[100%] flex  mx-auto">
        <div className="flex w-full justify-between items-center flex-wrap md-lg:gap-4">
          {/* Brands */}
          <div className="w-2/12 md-lg:w-full sm:pt-8 md-lg:pt-10 px-1">
            <div className="bg-white relative">
              <div
                onClick={() => setCategoryShow(!categoryShow)}
                className="h-[50px] sm:h-[45px] bg-neutral-100 text-black flex justify-center md-lg:justify-between md-lg:px-6 items-center gap-3 font-bold text-sm cursor-pointer"
              >
                <div className="flex justify-center items-center gap-4 text-md">
                  <span>
                    <FaList size={16} />
                  </span>
                  <span>{t('home.all_category')} </span>
                </div>
                <span className="pt-1 px-4">
                  <IoIosArrowDown size={18} />
                </span>
              </div>
              {/* <div className="fixed inset-0 z-50 bg-white overflow-y-auto sm:hidden"> */}
              {categoryShow && (
                <div className="absolute w-full pt-3 transition-all bg-[#f6f8f8] border border-neutral-50 z-[10] shadow-lg md-lg:relative">
                  {categoriesView?.map((c, i) => {
                    const matchingSubcategories = subCategories.filter(
                      (subcategory) => subcategory.categoryId === c._id,
                    )
                    return (
                      <div key={i} className="group relative">
                        <div className="py-3 hover:bg-neutral-200 border-b">
                          <Link
                            to={`/products?category=${c.enName}&categoryId=${c._id}`}
                            className="text-base block"
                            onClick={() => setCategoryShow(!categoryShow)}
                          >
                            <div className="w-full flex items-center justify-between px-2">
                              <div className="w-full flex items-center gap-2">
                                <img
                                  src={`${backend_url_img}/uploads/categories/${c.image}`}
                                  className="w-[20px] h-[20px] rounded-full overflow-hidden"
                                  alt=""
                                />
                                <span
                                  className={`text-md text-neutral-600 ${
                                    isRTL ? 'text-right' : 'text-left'
                                  }`}
                                >
                                  {getCategoryName(c)}
                                </span>
                              </div>
                              <div>
                                {matchingSubcategories.length > 0 && (
                                  <span className="text-sm text-neutral-600">
                                    {isRTL ? (
                                      <FaChevronLeft />
                                    ) : (
                                      <FaChevronRight />
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Link>
                        </div>
                        {matchingSubcategories.length > 0 && (
                          <div
                            className={`absolute top-0 ${
                              isRTL
                                ? 'right-full sm:right-0'
                                : 'left-full sm:left-0'
                            } z-[9999] w-64 hidden group-hover:block bg-neutral-50 border border-neutral-200 shadow-sm overflow-y-auto max-h-auto sm:max-h-[400px] md:max-h-[500px]`}
                          >
                            {matchingSubcategories.map((subCategory, index) => (
                              <div
                                key={index}
                                className="px-3 py-3 hover:bg-neutral-200 border-b"
                              >
                                <Link
                                  to={`/products?category=${c.enName}&categoryId=${c._id}&subCategoryId=${subCategory._id}`}
                                  className="text-base block"
                                  onClick={() => setCategoryShow(!categoryShow)}
                                >
                                  {getSubCategoryName(subCategory)}
                                </Link>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          </div>
          {/* Links */}
          <div className="flex justify-between items-center w-8/12 px-3 sm:px-4 md-lg:px-0 md-lg:w-full md-lg:hidden">
            <ul className="flex  gap-4 text-sm font-bold uppercase ">
              <li>
                <Link
                  to="/"
                  className={`p-2 block hover:text-primary ${
                    pathname === '/' ? 'text-primary' : 'text-slate-600'
                  } `}
                >
                  {t('home.home')}
                </Link>
              </li>

              <li>
                <Link
                  to="/categories"
                  className={`p-2 block ${
                    pathname === '/categories'
                      ? 'text-primary'
                      : 'text-slate-600'
                  } `}
                >
                  {t('products.brands')}
                </Link>
              </li>

              <li>
                <Link
                  to="/products"
                  className={`p-2 block ${
                    pathname === '/products' ? 'text-primary' : 'text-slate-600'
                  } `}
                >
                  {t('home.productList')}
                </Link>
              </li>

              <li>
                <Link
                  to="/about_us"
                  className={`p-2 block ${
                    pathname === '/about_us' ? 'text-primary' : 'text-slate-600'
                  } `}
                >
                  {t('home.about_us')}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={`p-2 block ${
                    pathname === '/contact' ? 'text-primary' : 'text-slate-600'
                  } `}
                >
                  {t('home.contact_us')}
                </Link>
              </li>
            </ul>

            {/* <div className="w-full flex  justify-end items-center"> */}
            <ul className="flex justify-end items-center gap-3">
              <li>
                <a
                  className="w-[38px] h-[38px] bg-[#e2e2e2] hover:bg-[#1877F2] hover:text-white flex justify-center items-center rounded-full"
                  href="https://"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF size={22} />{' '}
                </a>
              </li>

              <li>
                <a
                  className="w-[38px] h-[38px] bg-[#e2e2e2] hover:bg-[#E1306C] hover:text-white flex justify-center items-center  rounded-full"
                  href="https://www.instagram.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaInstagramSquare size={22} />{' '}
                </a>
              </li>
              {/* <li>
                            <a
                              className="w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-white rounded-full"
                              href="#"
                            >
                              <FaLinkedin />{' '}
                            </a>
                          </li>
                          <li>
                            <a
                              className="w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-white rounded-full"
                              href="#"
                            >
                              <FaGithub />{' '}
                            </a>
                          </li> */}
            </ul>
            {/* </div> */}
          </div>
        </div>
      </div>
      <button
        onClick={backToTop}
        type="button"
        data-twe-ripple-init
        data-twe-ripple-color="light"
        className="!fixed bottom-5 sm:bottom-32 md:bottom-32 end-8 sm:end-2  z-[9999] hidden rounded-full bg-darkRed p-3 text-xs font-medium uppercase leading-tight text-white hover:text-white shadow-md transition duration-150 ease-in-out hover:bg-[#000000] hover:shadow-lg focus:bg-[#000000]  focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#060104]  active:shadow-lg"
        id="btn-back-to-top"
      >
        <span className="[&>svg]:w-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="3"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
            />
          </svg>
        </span>
      </button>
    </div>
  )
}

export default Header
